<div class="dialog-wrapper">
  <div class="header">
    <h2 mat-dialog-title>{{ data?.title }}</h2>
    <mat-icon class="close" *ngIf="data?.showClose" title="{{ closeAction?.label }}"
      (click)="onDialogButtonClick($event, closeAction);">close</mat-icon>
  </div>
  <div class="content">
    <mat-dialog-content>
      <ng-container *ngComponentOutlet="data.component; 
        ndcDynamicInputs: data.componentInputs;
        ndcDynamicOutputs: {
          closeDialog: { handler: onDialogClose, args: ['$event', dialogRef] }
        }"></ng-container>
      <ng-container *ngIf="data?.content">
        <p [innerHTML]="data?.content"></p>
      </ng-container>
    </mat-dialog-content>
  </div>
  <div class="action" *ngIf="data?.showAction">
    <mat-dialog-actions>
      <ng-container *ngFor="let action of data?.actions;">
        <app-button [label]="action?.label" [labelPosition]="action?.labelPosition ?? BUTTON_LABEL_POSITION.PREFIX"
          [disabled]="action?.disabled ?? null" [type]="action?.type ?? BUTTON_TYPE.BUTTON"
          [icon]="action?.icon ?? null" [option]="action?.option ?? BUTTON_OPTION.BASIC"
          [color]="action?.color ?? (action?.type === BUTTON_TYPE.SUBMIT ? BUTTON_COLOR.PRIMARY : BUTTON_COLOR.SECONDARY )"
          (clicked)="onDialogButtonClick($event, action, data?.extras)">
        </app-button>
      </ng-container>
    </mat-dialog-actions>
  </div>
</div>